/*
 * parcelamento-12x.js
 * Mantem o texto "em até 12x de R$ X" sincronizado com o preco realmente exibido
 * (promocao, troca de variante, conteudo carregado por JS).
 * A parcela e SEMPRE preco_efetivo / 12 — nenhum valor fixo.
 */
(function () {
  'use strict';

  var PARCELAS = 12;

  function parseBRL(text) {
    if (!text) return NaN;
    var m = String(text).replace(/\s/g, ' ').match(/[\d.,]+/g);
    if (!m || !m.length) return NaN;
    // Em faixas ("de X a Y") o menor preco e o primeiro.
    var raw = m[0].replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    var v = parseFloat(raw);
    return isNaN(v) ? NaN : v;
  }

  function formatBRL(value) {
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  function currentPrice(node) {
    // Sobe ate um container de produto e pega o preco de venda (nao o riscado).
    var scope = node.closest(
      '.product-item, .product__info, .product-meta, .card, .grid__item, form, li, article'
    ) || node.parentElement;

    for (var i = 0; i < 4 && scope; i++) {
      var candidates = scope.querySelectorAll(
        '.price:not(.price--compare):not(.price--original), .price-list__price, [data-price]'
      );
      for (var j = 0; j < candidates.length; j++) {
        var el = candidates[j];
        if (el.closest('s, del, .price--compare, .price-list__price--compare')) continue;
        if (el.hasAttribute('data-price') && el.getAttribute('data-price')) {
          var cents = parseInt(el.getAttribute('data-price'), 10);
          if (!isNaN(cents) && cents > 0) return cents / 100;
        }
        var v = parseBRL(el.textContent);
        if (!isNaN(v) && v > 0) return v;
      }
      scope = scope.parentElement;
    }
    return NaN;
  }

  function refresh(node) {
    var price = currentPrice(node);
    if (isNaN(price) || price <= 0) return;
    var parcela = Math.round((price / PARCELAS) * 100) / 100;
    var target = node.querySelector('[data-parcelamento-value]') || node.querySelector('strong:last-of-type');
    if (!target) return;
    var texto = formatBRL(parcela);
    if (target.textContent.trim() !== texto) target.textContent = texto;
  }

  function refreshAll(root) {
    var nodes = (root || document).querySelectorAll('[data-parcelamento-12x]');
    for (var i = 0; i < nodes.length; i++) refresh(nodes[i]);
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      refreshAll(document);
    }, 120);
  }

  function init() {
    refreshAll(document);
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    ['variant:changed', 'variant:change', 'product:variant-change', 'shopify:section:load'].forEach(
      function (evt) {
        document.addEventListener(evt, schedule);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
